// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => elem.classList.add("mm-loading");

// MEGAMENU **********************************************************************************
/*********************************************************************************************
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 * @param {string} classElemToHide - The CSS selector for the element to hide.
 */
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow, classElemToHide = null) => {
	document.querySelectorAll(classElemsToHide).forEach((elem) => (elem.style.display = "none"));
	document.querySelector(classElemToShow).style.display = "flex";
	if (classElemToHide) {
		document.querySelectorAll(classElemToHide).forEach((elem) => (elem.style.display = "none"));
	}
};

/*********************************************************************************************
 * Adjust the position of the mega menu based on the header height.
 *
 */
const getMegaMenuPosition = () => {
	const header = document.querySelector("[data-mm-header]");
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.querySelectorAll("[data-megamenulink]").forEach((menuElem) => {
		const megaMenu = menuElem.nextElementSibling;
		if (megaMenu?.hasAttribute("data-megamenu")) {
			megaMenu.style.top = `${headerHeight - 1}px`;
		}
	});
};

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
 * Add background filter on hover over mega menu links.
 *
 */
const hoverBgFilter = () => {
	const header = document.querySelector("[data-mm-header]");
	const searchContainer = document.querySelector("[data-search-container]");
	const megaMenuLinks = document.querySelectorAll("[data-megamenulink]");
	const megaMenuWrappers = document.querySelectorAll("[data-megamenu]");
	const menuLinks = document.querySelectorAll("[data-menulink]");
	const filter = document.querySelector("[data-filter]");
	const cart = document.querySelector("[data-cart-filter]");
	// const mediasUGC = document.querySelector("[data-ugc-filter]");

	if (!header || !filter || !cart) return;

	const toggleFilter = (show) => {
		filter.classList.toggle("active", show);
	};

	const canHide = () => {
		return (!searchContainer || !searchContainer.classList.contains("mm-open")) && !cart.classList.contains("mm-dc-is-open");
	};

	// Afficher sur entrée d'un lien méga-menu
	megaMenuLinks.forEach((link) => {
		link.addEventListener("mouseenter", () => toggleFilter(true));
		// Cacher si on quitte le lien et qu'on ne va pas vers un autre lien méga-menu ni vers le wrapper
		link.addEventListener("mouseleave", (e) => {
			const to = e.relatedTarget;
			const goingToMegaLink = to && to.closest && to.closest("[data-megamenulink]");
			const goingToWrapper = to && to.closest && to.closest("[data-megamenu]");
			if (canHide() && !goingToMegaLink && !goingToWrapper) {
				toggleFilter(false);
			}
		});
	});

	// Maintenir affiché quand on entre dans le wrapper, cacher quand on le quitte (si on ne va pas vers un lien méga-menu)
	megaMenuWrappers.forEach((wrap) => {
		wrap.addEventListener("mouseenter", () => toggleFilter(true));
		wrap.addEventListener("mouseleave", (e) => {
			const to = e.relatedTarget;
			const goingToMegaLink = to && to.closest && to.closest("[data-megamenulink]");
			const goingToWrapper = to && to.closest && to.closest("[data-megamenu]");
			if (canHide() && !goingToMegaLink && !goingToWrapper) {
				toggleFilter(false);
			}
		});
	});

	menuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(false)));

	header.addEventListener("mouseleave", () => {
		if ((!searchContainer || !searchContainer.classList.contains("mm-open")) && !cart.classList.contains("mm-dc-is-open")) {
			toggleFilter(false);
		}
	});
};

/*********************************************************************************************
 * Show background filter.
 *
 */
const showBgFilter = (zIndex) => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	filter.classList.add("active");
	if (zIndex) filter.style.zIndex = zIndex;
};

/*********************************************************************************************
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty("z-index"), 700);
	filter.classList.remove("active");
};

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
 * Open external links in a new tab unless it's the consent modale.
 *
 */
const externalLink = () => {
	document.querySelectorAll("a:not(.consent-wrapper)").forEach((link) => {
		if (link.hostname !== window.location.hostname) {
			link.target = "_blank";
			link.rel = "noreferrer noopener";
		}
	});
};

/*********************************************************************************************
 * Fonction pour splide
 */
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
	const sections = document.querySelectorAll(`[${attributeName}]`);

	sections.forEach(function (section) {
		const splideElem = section.querySelector(className);

		if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
			// Appel dynamique de la fonction passée en paramètre
			initializeFunction(splideElem, section);
		}
	});
}

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
 * Toggle the mobile menu.
 *
 */
const mmMobileMenu = () => {
	if (window.innerWidth > 1024) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		html: document.querySelector("html"),
	};

	// Seuls ces éléments sont indispensables pour l'ouverture/fermeture
	const requiredForToggle = [elements.header, elements.icon, elements.mobileMenu, elements.html];
	if (requiredForToggle.some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;

	[header, icon, mobileMenu].forEach((el) => el.classList.toggle("mm-open"));
	html.classList.toggle("stop-scrolling");

	showBgFilter("var(--index-lg)");
};

/*********************************************************************************************
 * Close the mobile menu.
 *
 */
const mmCloseMobileMenu = (keepFilterActive = false) => {
	if (window.innerWidth > 1024) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		html: document.querySelector("html"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;

	[header, icon, mobileMenu].forEach((el) => el.classList.remove("mm-open"));
	html.classList.remove("stop-scrolling");

	if (!keepFilterActive) hideBgFilter();
};

/*********************************************************************************************
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowNext = (elemToShowClass) => {
	const elem = document.querySelector(elemToShowClass);
	if (elem) {
		elem.classList.add("mm-mobile-menu-elem-slided");
		elem.setAttribute("data-active", "true");
		// Optionnel : sur le conteneur principal
		document.querySelector(".mm-mobile-menu-container")?.setAttribute("data-active-level", elem.getAttribute("data-level"));
	}
};

/*********************************************************************************************
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowPrev = (elemToShowClass) => {
	const elem = document.querySelector(elemToShowClass);
	if (elem) {
		elem.classList.remove("mm-mobile-menu-elem-slided");
		elem.removeAttribute("data-active");
		// Optionnel : sur le conteneur principal
		document.querySelector(".mm-mobile-menu-container")?.setAttribute("data-active-level", parseInt(elem.getAttribute("data-level")) - 1);
	}
};

/*********************************************************************************************
 * Handle dropdown behavior.
 */
function handleDropdown(container = document) {
	const dropWrappers = container.querySelectorAll(".mm-faq-dropdown .dropdown");

	dropWrappers.forEach((item) => {
		if (!item.dataset.listenerAdded) {
			item.addEventListener("click", function () {
				dropWrappers.forEach((el) => {
					if (el !== this) {
						el.classList.remove("active");
						// Accessibilité: fermer les autres panneaux
						el.setAttribute("aria-expanded", "false");
						const content = el.nextElementSibling;
						if (content) {
							content.style.maxHeight = null;
							content.setAttribute("aria-hidden", "true");
							content.setAttribute("inert", "");
						}
					}
				});

				this.classList.toggle("active");
				const content = this.nextElementSibling;

				if (content) {
					const isActive = this.classList.contains("active");
					// Accessibilité: synchroniser aria-expanded et focusabilité des sous-liens
					this.setAttribute("aria-expanded", isActive ? "true" : "false");

					if (isActive) {
						content.style.maxHeight = content.scrollHeight + "px";
						content.setAttribute("aria-hidden", "false");
						content.removeAttribute("inert");
					} else {
						content.style.maxHeight = null;
						content.setAttribute("aria-hidden", "true");
						content.setAttribute("inert", "");
					}
				}
			});

			item.dataset.listenerAdded = "true";
		}
	});

	// Initialiser l'état selon la classe 'active' existante (ex: {% if forloop.first %}active{% endif %})
	dropWrappers.forEach((btn) => {
		const panel = btn.nextElementSibling;
		const isActive = btn.classList.contains("active");
		btn.setAttribute("aria-expanded", isActive ? "true" : "false");
		if (panel) {
			if (isActive) {
				panel.style.maxHeight = panel.scrollHeight + "px";
				panel.setAttribute("aria-hidden", "false");
				panel.removeAttribute("inert");
			} else {
				panel.style.maxHeight = null;
				panel.setAttribute("aria-hidden", "true");
				panel.setAttribute("inert", "");
			}
		}
	});
}

//  dropdown top
function handleDropdownTop(container = document) {
	const dropWrappers = container.querySelectorAll('[data-drop-top="dropdownTop"]');

	dropWrappers.forEach((item) => {
		if (!item.dataset.listenerAddedTop) {
			item.addEventListener("click", function () {
				dropWrappers.forEach((el) => {
					if (el !== this) {
						el.classList.remove("active");

						const prev = el.previousElementSibling;
						if (prev) {
							prev.classList.remove("active");
							prev.style.maxHeight = null;
						}

						const textEl = el.querySelector(".mm-text-video-ugc-info");
						if (textEl) textEl.textContent = "Voir les produits";
						el.style.bottom = "20px"; // reset la position
					}
				});

				this.classList.toggle("active");
				const content = this.previousElementSibling;
				const textEl = this.querySelector(".mm-text-video-ugc-info");

				if (content) {
					content.classList.toggle("active");

					if (content.classList.contains("active")) {
						const height = content.scrollHeight;
						content.style.maxHeight = height + "px";

						// Change le texte en "RÉDUIRE"
						if (textEl) textEl.textContent = "RÉDUIRE";

						// Déplace le bouton juste au-dessus du bloc
						this.style.bottom = `${height + 40}px`; // 40px pour l'espacement
					} else {
						content.style.maxHeight = null;
						if (textEl) textEl.textContent = "Voir les produits";
						this.style.bottom = "20px";
					}
				}
			});

			item.dataset.listenerAddedTop = "true";
		}
	});
}

document.addEventListener("DOMContentLoaded", function () {
	// Init sur toute la page
	handleDropdown();
	handleDropdownTop();

	// Spécifique à product-recommendations (AJAX Shopify)
	const observerTarget = document.querySelector("product-recommendations");

	if (observerTarget) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.addedNodes.length > 0) {
					// Réinitialise les dropdowns à l'intérieur
					handleDropdown(observerTarget);
					// handleDropdownTop(observerTarget);
				}
			});
		});

		observer.observe(observerTarget, {
			childList: true,
			subtree: true,
		});
	}
});

// SEARCH ************************************************************************************
/*********************************************************************************************
 * Show the search bar and related UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
const mmShowSearch = () => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;

	html.classList.add("stop-scrolling");
	search.classList.add("mm-open");
	showBgFilter();

	setTimeout(() => searchInput.focus(), 1000);

	document.getElementById("predictive-search")?.addEventListener("touchstart", () => {
		setTimeout(() => searchInput.blur(), 500);
	});
};

/*********************************************************************************************
 * Hide the search bar and revert UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
const mmHideSearch = (keepFilterActive = false, keepStopScrolling = false) => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;
	if (!keepStopScrolling) {
		html.classList.remove("stop-scrolling");
	}
	search.classList.remove("mm-open");
	if (!keepFilterActive) hideBgFilter();

	searchInput.value = "";
	searchInput.dispatchEvent(new Event("input"));
};

/*********************************************************************************************
 * Initialize parallax effect for slide images.
 *
 */
const mmInitParallax = () => {
	const images = document.querySelectorAll(".mm-slide-image");
	if (!images.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const slideImage = entry.target;
					const covers = slideImage.querySelectorAll(".mm-slide-image-cover");
					if (!covers.length) return;

					covers.forEach((cover) => {
						gsap.to(cover, {
							yPercent: 30,
							ease: "none",
							scrollTrigger: {
								trigger: slideImage,
								start: "top bottom",
								end: "bottom top",
								scrub: true,
							},
						});
					});

					observer.unobserve(slideImage);
				}
			});
		},
		{
			rootMargin: "0px 0px 200px 0px",
		}
	);

	images.forEach((image) => observer.observe(image));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
			const source = video.querySelector("source");
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

			video.load();
			video.play().catch((err) => console.warn("Auto-play failed:", err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
			video.pause();
			video.currentTime = 0;
			video.dataset.loaded = "false";
		}
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || (isDesktop && !isMobile) || (isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 *
 */
const documentHeight = () => {
	document.documentElement.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

/*********************************************************************************************
 * Custom element for product recommendations
 *
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
						// Réinitialiser la wishlist pour les nouvelles cartes de produits
						if (window.wishlistManager) {
							window.wishlistManager.initButtons();
						}
					} else {
						const parentElement = this.closest(".mm-section");
						if (parentElement) {
							parentElement.style.display = "none";
						}
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

/* Fonction pour splide *********************************************************************
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
	const sections = document.querySelectorAll(`[${attributeName}]`);

	sections.forEach(function (section) {
		const splideElem = section.querySelector(className);

		if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
			// Appel dynamique de la fonction passée en paramètre
			initializeFunction(splideElem, section);
		}
	});
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
	let scrollCounter = 0;

	splideElem.addEventListener("wheel", function (e) {
		if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
			return;
		}

		e.preventDefault();

		scrollCounter++;

		if (scrollCounter >= 12) {
			scrollCounter = 0;

			if (e.deltaX < 0) {
				splideInstance.go("<");
			} else if (e.deltaX > 0) {
				splideInstance.go(">");
			}
		}
	});
}

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	getMegaMenuPosition();
	hoverBgFilter();
	externalLink();
	documentHeight();
	mmInitParallax();
	mmInitVideoLazy();
	mmHeaderScrollClass();
});

/*********************************************************************************************
 * Resized Listenner
 *
 */
window.addEventListener("resize", () => {
	getMegaMenuPosition();
	documentHeight();
});

// Product Card **********************************************************************************
function mmInitProductCardVariants() {
    const containers = document.querySelectorAll('.mm-product-card-variants, .mm-product-card-simplifie-variants');
    containers.forEach(container => {
        // Check if any variant is visually selected
        const selected = container.querySelector('.mm-variant-selected');
        if (!selected) {
            // If none selected, select the first one visually
            const firstBtn = container.querySelector('.mm-variant-selector');
            if (firstBtn) {
                firstBtn.classList.add('mm-variant-selected');
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", mmInitProductCardVariants);

// Délégation globale des clics pour les variantes
document.addEventListener("click", function (e) {
    // Vérification de l'élément cible (gère les nœuds de texte)
    const targetElement = e.target.nodeType === 3 ? e.target.parentNode : e.target;
    const button = targetElement.closest(".mm-variant-selector");

	if (button) {
        // Empêche la propagation pour éviter les conflits avec le clic de la carte
		e.stopPropagation();

		const variantId = button.dataset.variantId;
		const productId = button.dataset.productId;
        const productUrl = button.dataset.productUrl;

		// 1. Mise à jour visuelle immédiate (UX)
		const variantContainer = button.closest(".mm-product-card-variants, .mm-product-card-simplifie-variants");
		if (variantContainer) {
			const variantButtons = variantContainer.querySelectorAll(".mm-variant-selector");
			variantButtons.forEach((btn) => btn.classList.remove("mm-variant-selected"));
			button.classList.add("mm-variant-selected");
		}

        // 2. Récupération du HTML de la carte mise à jour
        if (productUrl) {
            const baseUrl = productUrl.split('?')[0];
            const isSimplified = button.closest('.mm-product-card-simplifie');
            const view = isSimplified ? 'card-refresh-simplified' : 'card-refresh';
            const fetchUrl = `${baseUrl}?variant=${variantId}&view=${view}`;
            
            fetch(fetchUrl)
                .then(response => {
                    if (!response.ok) throw new Error("Erreur réseau");
                    return response.text();
                })
                .then(responseText => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    
                    // Recherche de la nouvelle carte produit (par ID ou classe)
                    let newProductCard = html.getElementById(productId);
                    if (!newProductCard) {
                        newProductCard = html.querySelector('.mm-product-card');
                    }

                    const currentProductCard = document.getElementById(productId);

                    if (newProductCard && currentProductCard) {
                        // Remplacement du contenu de la carte
                        currentProductCard.innerHTML = newProductCard.innerHTML;
                        
                        // Réinitialisation des variants si nécessaire
                        mmInitProductCardVariants(); 
                    } 
                })
                .catch(err => console.error("Erreur maj carte produit:", err));
        }
	}
});

// Judge me
function updateRatings() {
	var ratingPairs = document.querySelectorAll(".jdgm-preview-badge");
	ratingPairs.forEach(function (badge) {
		var container = badge.closest(".product-card") || badge.parentElement;
		if (container) {
			var ratingContainer = container.querySelector(".mm-product-rating");
			var customRating = container.querySelector(".custom-rating");
			if (ratingContainer && customRating) {
				var ratingElement = badge.querySelector(".jdgm-prev-badge[data-average-rating]");
				if (ratingElement) {
					var rating = ratingElement.getAttribute("data-average-rating");
					if (rating && parseFloat(rating) > 0) {
						customRating.textContent = (parseFloat(rating) || 0).toFixed(1);
						ratingContainer.style.display = "flex";
					}
				}
			}
		}
	});
}

function tryUpdateRatings() {
	var badges = document.querySelectorAll(".jdgm-prev-badge[data-average-rating]");
	if (badges.length > 0) {
		updateRatings();
	} else {
		setTimeout(tryUpdateRatings, 100);
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", tryUpdateRatings);
} else {
	tryUpdateRatings();
}

/**
 * Hide all sublinks containers and show the cards list container for the given index.
 * @param {string|number} index - The index to target the correct containers.
 */
function mmMegaMenuHideProducts(index) {
	// Hide all sublinks containers for this index
	document.querySelectorAll(".mm-mega-menu-sublinks-container-" + index).forEach((elem) => {
		elem.style.display = "none";
	});
	// Show the cards list container for this index
	document.querySelectorAll(".mm-mega-menu-cards-list-container-" + index).forEach((elem) => {
		elem.style.display = "";
	});
}

/**
 * Ajoute une classe au header lors du scroll vers le bas, la retire en haut de page
 */
function mmHeaderScrollClass() {
	const header = document.querySelector(".mm-section-header");
	if (!header) return;
	window.addEventListener("scroll", () => {
		if (window.scrollY > 0) {
			header.classList.add("mm-header-scrolled");
		} else {
			header.classList.remove("mm-header-scrolled");
		}
	});
}
